import React from 'react'

const LoadingText = () => {
  return (
    <h4 className="loading-text">
      Loading more templates<span className="dots">
        <span>.</span><span>.</span><span>.</span><span>.</span>
      </span>
    </h4>
  )
}

export default LoadingText